(() => {
  const replacements = {
  "490993692_30176706195261638_213823243629067637_n-24_aca0f868-4691-4d71-bfd9-43dc21019c5d.jpg": "https://cdn.shopify.com/s/files/1/1013/3805/5038/files/pt-auskarai-swarovski-neutralus-v2.png?v=1791308737",
  "kolekcija-16015152972158.png": "https://cdn.shopify.com/s/files/1/1013/3805/5038/files/pt-auskarai-perlai-neutralus-v2.png?v=1791308754"
};
  const replaceImage = (img) => {
    const source = img.getAttribute('src') || img.getAttribute('data-src') || '';
    const match = Object.entries(replacements).find(([filename]) => source.includes('/' + filename));
    if (!match) return;
    const url = match[1];
    img.setAttribute('src', url);
    img.setAttribute('srcset', [180, 360, 540, 720, 960, 1254].map(width => url + '&width=' + width + ' ' + width + 'w').join(', '));
    if (img.hasAttribute('data-src')) img.setAttribute('data-src', url);
  };
  const scan = (root) => {
    if (root.nodeType !== 1) return;
    if (root.tagName === 'IMG') replaceImage(root);
    root.querySelectorAll('img').forEach(replaceImage);
  };
  scan(document.documentElement);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') replaceImage(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset', 'data-src']});
})();
